require('./bootstrap.js');
window.Vue = require('vue');

import store from './store';

import { rutInputDirective } from 'vue-dni';

import multiselect from './components/multiselect';
import VueToast from 'vue-toast-notification';
import navbar from './pages/reservations/navbar.vue';
import login from './components/login.vue';
import sidebar from './components/sidebar.vue';
import sidebarMimed from './pages/reservations/sidebar-mimed.vue';
import upload from './components/upload.vue';
import pagination from './components/pagination.vue';
import scheduleBadge from './components/schedule-badge.vue';
import reservationBadge from './components/reservation-badge';
import lockBadge from './components/lock-badge';
import daySelector from './components/day-selector';
import maskedInput from 'vue-masked-input';
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue';
import vSelect from 'vue-select';
import Vuelidate from 'vuelidate';
import VueSlider from 'vue-slider-component';
import VCalendar from 'v-calendar';
import VueCountdown from '@chenfengyuan/vue-countdown';

import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import 'vue-slider-component/theme/default.css';

Vue.use(Vuelidate);
Vue.use(VCalendar);
Vue.component('navbar', navbar);
Vue.component('login', login);
Vue.component('sidebar', sidebar);
Vue.component('sidebar-mimed', sidebarMimed);
Vue.component('v-upload-file', upload);
Vue.component('v-pagination', pagination);
Vue.component('schedule-badge', scheduleBadge);
Vue.component('reservation-badge', reservationBadge);
Vue.component('lock-badge', lockBadge);
Vue.component('day-selector', daySelector);
Vue.component('multiselect', multiselect);
Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker);
Vue.component('masked-input', maskedInput);
Vue.component('v-select', vSelect);
Vue.component(VueCountdown.name, VueCountdown);
Vue.component('schedule-index-page', () => import('./pages/schedule'));

Vue.component('public-index-page', () => import('./pages/public'));
Vue.component('public-navbar', () => import('./pages/public/components/navbar'));
Vue.component('private-navbar', () => import('./pages/reservations/navbarPrivate'));
Vue.component('public-footer', () => import('./pages/public/components/footer'));
Vue.component('private-footer', () => import('./pages/reservations/footerPrivate'));

Vue.component('old-public-search', () => import('./pages/public/components/old_search'));
Vue.component('public-search', () => import('./pages/public/components/search'));
Vue.component('desktop-filter', () => import('./pages/public/components/search/desktopFilter'));

Vue.component('public-links', () => import('./pages/public/components/links'));
Vue.component('public-slider', () => import('./pages/public/components/slider'));
Vue.component('reservation-index', () => import('./pages/reservations/index'));
Vue.component('reservations-view', () => import('./pages/reservations/components/reservations'));
Vue.component('history-index', () => import('./pages/reservations/components/history'));
Vue.component('orders-index', () => import('./pages/reservations/components/orders'));
Vue.component('meet-index', () => import('./pages/meet/index'));
Vue.component('simplekey-page', () => import('./pages/simplekey'));
Vue.component('prescription-index', () => import('./pages/reservations/components/prescription'));
Vue.component('licenses-index', () => import('./pages/reservations/components/licenses'));
Vue.component('license-detail', () => import('./pages/reservations/components/detail'));
Vue.component('gesNotification', () => import('./pages/reservations/components/ges'));
Vue.component('bonoHistory-index', () => import('./pages/reservations/components/bonoHistory'));
Vue.component('bonoDetail-detail', () => import('./pages/reservations/components/bonoDetail'));
Vue.component('profile-index', () => import('./pages/reservations/components/profile/index'));
Vue.component('profile', () =>
  import('./pages/reservations/components/profile/components/profile')
);
Vue.component('tyc', () => import('./pages/reservations/components/profile/components/tyc'));
Vue.component('restore-password', () => import('./pages/restorePassword'));
Vue.component('forgot-password', () =>
  import('./pages/restorePassword/components/forgotPassword')
);
Vue.component('under-age', () =>
  import('./pages/reservations/components/profile/components/underAge/underAge')
);
Vue.component('add-under-age', () =>
  import('./pages/reservations/components/profile/components/underAge/addUnderAge')
);
Vue.component('under-age-list', () =>
  import('./pages/reservations/components/profile/components/underAge/UnderAgeList')
);
Vue.component('under-age-table', () =>
  import('./pages/reservations/components/profile/components/underAge/underAgeTable')
);
Vue.component('edit-under-age', () =>
  import('./pages/reservations/components/profile/components/underAge/editUnderAge')
);

Vue.component('vaccine-card', () =>
  import('./pages/reservations/components/profile/components/vaccines/vaccineCard')
);
Vue.component('add-vaccine', () =>
  import('./pages/reservations/components/profile/components/vaccines/addVaccine')
);
Vue.component('list-vaccine', () =>
  import('./pages/reservations/components/profile/components/vaccines/listVaccine')
);
Vue.component('list-vaccine-mobile', () =>
  import('./pages/reservations/components/profile/components/vaccines/listVaccineMobile')
);

Vue.component('register-password', () => import('./pages/register/components/password'));

Vue.component('register-index', () => import('./pages/register'));
Vue.component('register-index', () => import('./pages/register/index'));
Vue.component('register-form', () => import('./pages/register/components/register'));
Vue.component('login-index', () => import('./pages/login'));

Vue.component('changepassword-index', () => import('./pages/changepassword/index'));
Vue.component('changepassword-form', () =>
  import('./pages/changepassword/components/changepassword')
);
Vue.component('update-password', () =>
  import('./pages/reservations/components/profile/components/updatePassword')
);

Vue.component('validations-index', () => import('./pages/meet/components/validations/index'));
Vue.component('cam', () => import('./pages/meet/components/validations/cam'));
Vue.component('bandwidth', () => import('./pages/meet/components/validations/bandwidth'));
Vue.component('speaker', () => import('./pages/meet/components/validations/speaker'));
Vue.component('microphone', () => import('./pages/meet/components/validations/mic'));

Vue.component('error-label', () => import('./components/modals/error'));
Vue.component('modal-logout', () => import('./components/modals/logout'));
Vue.component('reservation-feed', () => import('./components/modals/reservation-feed'));
Vue.component('error-modal', () => import('./components/modals/errorModal'));
Vue.component('error-modal-bono', () => import('./components/modals/errorModalBono'));
Vue.component('success-modal', () => import('./components/modals/successModal'));
Vue.component('success-modal-remove-user', () =>
  import('./components/modals/successModalRemoveUser')
);
Vue.component('unregistered-restore-password-modal', () => import('./components/modals/unregisteredRestorePassword'));
Vue.component('confirmation-modal', () => import('./components/modals/confirmationModal'));
Vue.component('tyc-modal', () => import('./components/modals/tycModal'));
Vue.component('login-modal', () => import('./components/modals/loginModal'));
Vue.component('email-warning-modal', () => import('./components/modals/emailWarningModal'));
Vue.component('confirmation-modal-reason-remove', () =>
  import('./components/modals/confirmationModalReasonRemoveUser')
);
Vue.component('confirmation-modal-remove-user', () =>
  import('./components/modals/confirmationModalRemoveUser')
);
Vue.component('error-schedule', () => import('./components/modals/errorScheduleModal'));
Vue.component('reload-modal', () => import('./components/modals/reloadModal'));
Vue.component('search-nearest-locations-modal', () =>
  import('./components/modals/searchNearestLocations')
);
Vue.component('suBono-register', () => import('./components/modals/suBonoRegisterModal'));
Vue.component('saveVaccine-modal', () => import('./components/modals/saveVaccineModal'));
Vue.component('insuranceNotification-modal', () =>
  import('./components/modals/insuranceNotificationModal')
);
Vue.component('error-modal-code', () => import('./components/modals/errorModalCode'));
Vue.component('filter-modal', () => import('./components/modals/filterModal'));

Vue.component('public-subono-page', () => import('./pages/subono'));
Vue.component('VueSlider', VueSlider);

Vue.directive('rut', rutInputDirective);

Vue.use(VueToast);
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);

Vue.component('forward-sms', () => import('./components/modals/forwardSmsModal'));

import VueTippy, { TippyComponent } from 'vue-tippy';
import Vue from 'vue';

Vue.use(VueTippy);
Vue.component('tippy', TippyComponent);

const app = new Vue({
  el: '#app',
  store,
});
